import axios from '@axios'

const useUploadFile = () => {
  const uploadFile = (file, type = '', alt = '', lang = 'fa') => new Promise((resolve, reject) => {
    if (!file) { reject(new Error('No file selected')); return }
    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', type)
    formData.append('alt', alt)
    axios
      .post('files/file', formData, { headers: { 'Content-Type': 'multipart/form-data', lang } })
      .then(res => resolve({ value: res.data, type }))
      .catch(e => reject(e))
  })
  const uploadFiles = files => {
    if (!files || !Array.isArray(files) || files.length === 0) return null
    const promiseArray = files.map(item => uploadFile(item.value, item.type, item.alt, item.lang))
    return Promise.all(promiseArray)
  }
  const checkFilesToUpload = files => {
    const filesToUpload = files.filter(file => {
      if (!file.value) return false
      if (file.value._id) return false
      return true
    })
    const filesNoUpload = files.filter(file => file.value && file.value._id)
    return {
      filesToUpload,
      filesNoUpload,
    }
  }

  return {
    uploadFiles,
    checkFilesToUpload,
  }
}
export default useUploadFile
